import React from 'react'
import Footer from '../../../componenets/footer/Footer'
import FloatingNavbar from '../../../componenets/floatingnavbar/FloatingNavbar'
import TAHomeContainer from '../../../containers/thrustarea/home/TAHomeContainer'

function TAHome() {
  return (
    <div className="admin-dashboard-page">
      <TAHomeContainer />
    </div>
  )
}

export default TAHome